import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export default function useAuthFlowRouteGuard(condition) {
  const history = useHistory();
  const shouldRender = Boolean(condition);

  useEffect(() => {
    if (!shouldRender) history.replace('/');
  }, [shouldRender, history]);

  return shouldRender;
}
